<template>
  <CheckboxExpansionPanel
    :on-checkbox-clicked="onCheckboxClicked"
    :panel-label="panelLabel"
    :model="modelValue"
  >
    <template v-slot:headerContent>
      <v-row
        align="center"
        class="expansion-panel-header-row"
      >
        <h1
          class="expansion-panel-header"
          :style="cssColorProp"
        >
          {{ leadingPanelData }}
        </h1>
        <v-icon
          class="mx-2"
          small
          color="var(--color-text)"
        >
          mdi-dots-horizontal
        </v-icon>
        <h1
          class="expansion-panel-header"
          :style="cssColorProp"
        >
          {{ trailingPanelData }}
        </h1>
      </v-row>
    </template>
    <template v-slot:panelContent>
      <SolutionDataPanelContent
        :voyage-duration-data="voyageDurationData"
        :consumption-data="consumptionData"
        :emissions-data="emissionsData"
        :distance-data="distanceData"
        :total-fuel-savings="totalFuelSavings"
        :time-savings="timeSavings"
      />
    </template>
  </CheckboxExpansionPanel>
</template>

<script>
import CheckboxExpansionPanel from "../../../components/CheckboxExpansionPanel.vue";
import SolutionDataPanelContent from "./SolutionDataPanelContent.vue";

export default {
  name: "SolutionDataPanel",
  components: { SolutionDataPanelContent, CheckboxExpansionPanel },
  props: {
    onCheckboxClicked: {
      type: Function,
      default: () => {},
    },
    panelLabel: {
      type: String,
      default: "",
    },
    leadingPanelData: {
      type: String,
      default: "",
    },
    trailingPanelData: {
      type: String,
      default: "",
    },
    voyageDurationData: {
      type: Number,
      default: 0,
    },
    consumptionData: {
      type: Number,
      default: 0,
    },
    emissionsData: {
      type: Number,
      default: 0,
    },
    distanceData: {
      type: Number,
      default: 0,
    },
    totalFuelSavings: {
      type: Number,
      default: 0,
    },
    timeSavings: {
      type: Number,
      default: 0,
    },
    model: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    cssColorProp() {
      return { "--color": this.color };
    },
    modelValue: {
      get() {
        return this.model;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
};
</script>

<style scoped>
.expansion-panel-header {
  font-size: 12px;
  color: var(--color);
  opacity: 0.8;
}
.expansion-panel-header-row {
  width: fit-content;
}
</style>
